export default "<div class=\"chip-text-only\">\n  {{ item.text }}\n</div>\n"